import { Card } from "@aqar-app/aqar-design-system";
import classNames from "classnames/bind";
import styles from "./.module.scss";
import { getPreviewToken } from "@/lib/paymentHelpers";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { Button, Input } from "@aqar-app/react-ui";

const cx = classNames.bind(styles);

function PlanCard({ plan, editableValue, index }) {
  const router = useRouter();
  const [value, setValue] = useState(plan?.value || 0);
  const {
    pkgType,
    category_name: type,
    disabled,
    action,
    actionTitle,
    administrative_fee_id,
  } = plan || {};
  const { features, title } = JSON.parse(plan.description || "{}")?.ar || {
    ar: {},
  };
  const handleSubmit = async () => {
    const { token: previewToken } = await getPreviewToken({
      type,
      pkgType,
      action,
      title,
      value,
      contract_id: plan.contract_id,
      listing_id: plan.listing_id,
      option: plan.option,
      administrative_fee_id,
    });
    return router.push({
      pathname: "/payment-gateway/checkout",
      query: { preview: previewToken },
    });
  };

  return (
    <Card className={styles.planCard} key={title}>
      <strong>
        <div
          className={cx(styles.planValue, {
            premium: index === 1,
            professional: index === 2,
            basic: !index,
          })}
        >
          {editableValue && (
            <Input
              type="number"
              value={value}
              onChange={(e) => setValue(Number(e.target.value))}
            />
          )}
          {!editableValue && <div>{(value || "").toLocaleString("en-GB")}</div>}
          <div>ريال</div>
        </div>
      </strong>
      <div className={styles.planContent}>
        <div className={styles.planHeader}>
          <div>{title}</div>
          <div className={styles.planDescription}>{features?.[0]}</div>
        </div>
        <Button
          disabled={disabled || !value}
          theme="primary"
          className={styles.actionButton}
          onClick={handleSubmit}
        >
          {actionTitle}
        </Button>
      </div>
    </Card>
  );
}

export default PlanCard;
